export const ERROR_MESSAE = 'try again after some time'

export const PASSWORD_SHARED_TO_EAMIL =
  'Password is shared to your registered email ID.'

export const USER_REGISTERED_SUCESSFULLY =
  'User has been registered Succesfully.'

export const REGISTRATION_NOTIFICATION = {
  TRY_AGAIN_AFTER_SOMETIME: 'Please try again after some time...',
  PLEASE_RELOAD_TRY_AGAIN: 'Please reload the page and try again...',
  ERROR_ENCOUNTERED_WHILE_FETCHING_POLICY_DETAILS:
    'Encountered an error while fetching policy details.',
}
